/**
 * Returns {start, end} segments where AD template events should be created.
 */
export function collectAdTemplateGaps(sourceEvents, projectDuration, minGapSeconds) {
    const gaps = [];
    let start = 0;

    sourceEvents.forEach((event) => {
        const end = event.start;
        if (end - start >= minGapSeconds) {
            gaps.push({ start, end });
        }
        start = event.end;
    });

    if (projectDuration && projectDuration > start) {
        gaps.push({ start, end: projectDuration });
    }

    return gaps;
}
